export default __webpack_public_path__ + "static/media/code-heel.6b84d9ef.mp4";